export const buildCameraPreviewDataUrl = async ({
  image,
  temperature = '',
  pressure = '',
  status = '',
  serialNumber = '',
  width = 640,
  height = 480
}) => {
  if (!image || typeof image === 'string') {
    return '';
  }

  const canvas = document.createElement('canvas');
  canvas.width = width || image.width || 640;
  canvas.height = height || image.height || 480;

  const context = canvas.getContext('2d');
  if (!context) {
    return '';
  }

  context.drawImage(image, 0, 0, canvas.width, canvas.height);

  context.fillStyle = 'rgba(10, 18, 28, 0.65)';
  context.fillRect(12, 12, Math.min(280, canvas.width - 24), 110);

  context.font = 'bold 22px sans-serif';
  context.fillStyle = '#ffffff';
  context.textAlign = 'left';
  context.textBaseline = 'top';

  const lines = [
    serialNumber ? `Device: ${serialNumber}` : 'Device: unknown',
    temperature ? `Temp: ${temperature}` : 'Temp: --',
    pressure ? `Pressure: ${pressure}` : 'Pressure: --',
    status ? `Status: ${status}` : 'Status: idle'
  ];

  lines.forEach((line, index) => {
    context.fillText(line, 24, 24 + index * 24);
  });

  return canvas.toDataURL('image/jpeg', 0.85);
};
